import {
  XUX_GRID_ACTIONS,
  XuxGridActionPayload,
} from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/grid-action.type';

export enum CUSTOM_XUX_GRID_ACTIONS {
  EXIT_EDITING_MODE = 'EXIT_EDITING_MODE',
  TAB_TO_NEXT_CELL = 'TAB_TO_NEXT_CELL',
  TAB_TO_PREVIOUS_CELL = 'TAB_TO_PREVIOUS_CELL',
  NAVIGATE_TO_NEXT_CELL = 'NAVIGATE_TO_NEXT_CELL',
  CELL_CLICKED = 'CELL_CLICKED',
}

export interface CustomXuxGridAction {
  type: XUX_GRID_ACTIONS | CustomXuxGridAction;
  payload?: XuxGridActionPayload;
}
